
export function generateHash() {
	return crypto.randomUUID();
}
